import type { FieldError } from 'react-hook-form';

/**
 * RHF の FieldError から表示用エラーメッセージ配列を抽出する純粋関数。
 *
 * - `criteriaMode: 'all'` 時に存在する複数エラー（`error.types`）を優先する
 * - `string` 型かつ truthy な値のみをメッセージとして採用する
 * - `boolean` / `number` など string 以外の値は除外する
 *   （旧 `@hookform/error-message` 経由のレンダリングで React が boolean/null/undefined を
 *   描画しない挙動と等価にするため。なお number は React が描画する仕様だが、
 *   `criteria mode: 'all'` で boolean が混入するケースへの防御として除外する）
 *
 * @param error - useController の fieldState.error
 */
type IExtractErrorMessages = (error: FieldError | undefined) => string[] | undefined;

export const extractErrorMessages: IExtractErrorMessages = error => {
  if (!error) return undefined;
  if (error.types) {
    return Object.values(error.types).flatMap(value => {
      if (Array.isArray(value)) return value.filter(item => typeof item === 'string' && item);
      if (typeof value === 'string' && value) return [value];
      return [];
    });
  }
  if (error.message) return [error.message];
  return undefined;
};
